import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Dialog, Form, Button, TextField, Selector} from 'components/core';
import {IconButton} from '@material-ui/core';
import {HighlightOff, Add} from '@material-ui/icons';

const styles = makeStyles((theme) => ({
    verificationContainer: {
        width: "100%",
        // height: 56,
        display: "flex",
        // padding: 10,
        margin: 10,
        // backgroundColor: theme.palette.input.background
    },
    verificationType: {
        float: "left",
        width: "300px",
        marginRight: 10
    },
    verificationTitle: {
        width: "100%",
    },
    verificationDelete: {
        marginTop: 20
    }
  }), {name: "StepsDialog"});

export default function StepVerifications({value, onChange=()=>{}})
{
    const [verifications, setVerifications] = React.useState(value);

    const changeValues = React.useCallback(function changeValues(newValues)
    {
        setVerifications(newValues);
        onChange(newValues);

    }, [onChange]);

    React.useEffect(function updateVerifications() 
    {
        setVerifications(value);
    }, [value]);

    const deleteVerification = React.useCallback(function deleteVerification(index)
    {
        let verificationsCopy = [...verifications];
        verificationsCopy.splice(index, 1);
        changeValues(verificationsCopy);
    }, [verifications, changeValues]);

    const addVerification = React.useCallback(function addVerification()
    {
        let verificationsCopy = [...verifications];
        verificationsCopy.push({verificationType: "text", name: "Nueva comprobación"});
        changeValues(verificationsCopy);
    }, [verifications, changeValues]);

    const updateCallback = React.useCallback(function updateVerification(index, value)
    {
        let verificationsCopy = [...verifications];
        verificationsCopy[index] = value;
        changeValues(verificationsCopy);
    }, [verifications, changeValues]);

    return <>
        {verifications.map((verification, index) => <SingleVerification verification={verification} index={index} key={index} onDelete={(index)=>deleteVerification(index)} onChange={(index, value) => updateCallback(index, value)} />)}
        
        <Button fullWidth={false} color="primary" onClick={()=>addVerification()}><Add />Añadir Campo</Button>
    </>

    
}


function SingleVerification({verification, index, onChange=()=>{}, onDelete=()=>{}})
{
    const classes = styles();
    const verificationTypes = [
        {
            value: "text",
            content: "Texto corto"
        },
        {
            value: "textarea",
            content: "Texto largo"
        },
        {
            value: "bool_slider",
            content: "Confirmación"
        },
        {
            value: "ar_activation",
            content: "Uso de Realidad Aumentada"
        },
        {
            value: "picture",
            content: "Fotografía"
        },
    ];

    function deleteVerification()
    {
        onDelete(index);
    }

    function onUpdateName(e)
    {
        verification.name = e.target.value;
        onChange(index, verification);
    }

    function onUpdateType(e)
    {
        verification.verificationType = e.target.value;
        onChange(index, verification);
    }
    
    return <div className={classes.verificationContainer}>
            <div className={classes.verificationType}><Selector label="Tipo" items={verificationTypes} value={verification.verificationType} onChange={onUpdateType}/></div>
            {verification.verificationType !== "ar_activation" ? <div className={classes.verificationTitle}><TextField label="Nombre" value={verification.name} onChange={onUpdateName}/></div> : null }
            <div className={classes.verificationDelete}> <IconButton onClick={()=>deleteVerification()}> <HighlightOff /> </IconButton> </div>
        </div>
}